import { type LandingPageTestimonial } from '@/app/components/LandingPage/LandingPageTestimonials/types';

const sleepAndRestTestimonials: LandingPageTestimonial[] = [
  {
    id: 'rhonda-c',
    image: {
      alt: 'sleep_and_rest_hero_one_img_alt',
      src: '/blue-sky/sleep-and-rest/sleep-and-rest-testimonials-one',
    },
    name: 'Rhonda C.',
    quote: 'sleep_and_rest_testimonial_one_quote',
    tag: 'sleep_and_rest_testimonial_one_eyebrow',
  },
  {
    id: 'nicole-v',
    image: {
      alt: 'sleep_and_rest_testimonials_two_img_alt',
      src: '/blue-sky/sleep-and-rest/sleep-and-rest-testimonials-two',
    },
    name: 'Nicole V.',
    quote: 'sleep_and_rest_testimonial_two_quote',
    tag: 'sleep_and_rest_testimonial_two_eyebrow',
  },
  {
    id: 'alec-u',
    image: {
      alt: 'sleep_and_rest_testimonials_three_img_alt',
      src: '/blue-sky/sleep-and-rest/sleep-and-rest-testimonials-three',
    },
    name: 'Alec U.',
    quote: 'sleep_and_rest_testimonial_three_quote',
    tag: 'sleep_and_rest_testimonial_three_eyebrow',
  },
];

export default sleepAndRestTestimonials;
